import clsx from "clsx";
import { Spin } from "antd";

type LoadingScreenInternalProps = {
  ariaLabel?: string;
  wScreenDisabled?: boolean;
  hScreenDisabled?: boolean;
};

export function LoadingScreenInternal({
  ariaLabel,
  wScreenDisabled,
  hScreenDisabled,
}: LoadingScreenInternalProps) {
  return (
    <div
      className={clsx(
        { "w-screen": !wScreenDisabled, "h-screen": !hScreenDisabled, "h-full": hScreenDisabled },
        "flex justify-center items-center"
      )}
      aria-label={ariaLabel}
      role="status"
    >
      <Spin size="large" />
    </div>
  );
}
